/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Mark_Done_Aria_LabelInputs */

const en_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark notes as done`)
};

const fr_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer les notes comme terminees`)
};

const de_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markieren Sie die Notizen als erledigt.`)
};

const it_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna le note come completate`)
};

const ru_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отметить заметки как выполненные`)
};

const es_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar notas como realizadas`)
};

const zh_cn2_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记笔记已完成`)
};

const ja_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモを完了としてマークする`)
};

const hi_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स को पूरा हुआ चिह्नित करें`)
};

const pt_pt2_notes_mark_done_aria_label = /** @type {(inputs: Notes_Mark_Done_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar notas como concluídas`)
};

/**
* | output |
* | --- |
* | "Mark notes as done" |
*
* @param {Notes_Mark_Done_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_mark_done_aria_label = /** @type {((inputs?: Notes_Mark_Done_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Mark_Done_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_mark_done_aria_label(inputs)
	if (locale === "de") return de_notes_mark_done_aria_label(inputs)
	if (locale === "it") return it_notes_mark_done_aria_label(inputs)
	if (locale === "ru") return ru_notes_mark_done_aria_label(inputs)
	if (locale === "es") return es_notes_mark_done_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_mark_done_aria_label(inputs)
	if (locale === "ja") return ja_notes_mark_done_aria_label(inputs)
	if (locale === "hi") return hi_notes_mark_done_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_mark_done_aria_label(inputs)
	return en_notes_mark_done_aria_label(inputs)
});